import React, { useContext } from "react";
import { UserContext } from "../UserContext";
import OperatorDevicesPanel from "./OperatorDevicesPanel";
import "./DevicesModal.css";

/**
 * The logged-in admin's / operator's own network devices (OLTs, switches), opened from the
 * dashboard's Devices button. Only Sync is offered here.
 */
const DevicesModal = ({ onClose }) => {
  const { user } = useContext(UserContext);
  return (
    <div className="dvm-overlay" role="dialog" aria-modal="true" aria-label="My devices" onClick={onClose}>
      <div className="dvm-modal" onClick={(e) => e.stopPropagation()}>
        <OperatorDevicesPanel
          operator={{ phoneNumber: user?.phoneNumber, operatorName: user?.operatorName }}
          onBack={onClose}
          backLabel="✕ Close"
          syncOnly
        />
      </div>
    </div>
  );
};

export default DevicesModal;
